/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Button
} from "shards-react";
import sample from "../../images/sampleImage.png";
const a = require("../../images/sampleImage.png");

const SidebarActions = props => {
  const { setImage, image } = props;
  const [imageUrl, setImageUrl] = useState("");

  useEffect(
    () => {
      console.log(image);
    },
    [image]
  );
  const imageInput = e => {
    e.preventDefault();
    const {
      target: { files }
    } = e;
    const file = files[0];
    if (file === undefined) {
      return;
    }
    setImage(file);
    const imageUrl = URL.createObjectURL(file);
    setImageUrl(imageUrl);
  };
  return (
    <Card small className="mb-3">
      <CardHeader className="border-bottom">
        <h6 className="m-0">Actions</h6>
      </CardHeader>

      <CardBody className="p-0">
        <ListGroup flush>
          <div
            className="card-post__image"
            style={{
              // backgroundImage: `url(${a})`,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              minHeight: "200px",
              backgroundSize: "cover",
              position: "relative"
            }}
          >
            <img
              src={
                image !== null
                  ? typeof image === "object"
                    ? imageUrl
                    : image
                  : a
              }
              alt="media"
              style={{
                // backgroundImage: `url(${imageUrl || a})`,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                minHeight: "200px",
                
                backgroundSize: "cover",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 10
              }}
            />
          </div>
          <ListGroupItem className="d-flex px-3 border-0">
            <Button
              outline
              theme="danger"
              size="sm"
              onClick={() => {
                setImage(sample);
              }}
            >
              사진삭제
            </Button>
            <Button
              outline
              theme="accent"
              size="sm"
              className="ml-auto"
              style={{ position: "relative", cursor: "pointer" }}
            >
              <input
                type="file"
                className="custom-file-input"
                id="customFile2"
                onChange={imageInput}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  width: "100%",
                  minWidth: 0,
                  cursor: "pointer"
                }}
                name="img"
              />
              {/* <i className="material-icons">file_copy</i> Publish */}
              사진추가
            </Button>
          </ListGroupItem>
        </ListGroup>
      </CardBody>
    </Card>
  );
};

SidebarActions.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string
};

SidebarActions.defaultProps = {
  title: "Actions"
};

export default SidebarActions;
